import { MessageCircle } from 'lucide-react';
import { useT } from '@/lib/i18n';

interface ChatErrorStateProps {
  error?: string | null;
}

export function ChatErrorState({ error }: ChatErrorStateProps) {
  const { t } = useT();
  return (
    <div className="flex flex-col items-center justify-center h-full pt-16 px-4">
      <MessageCircle className="w-16 h-16 text-dark-muted mb-4" />
      <h2 className="text-xl font-semibold mb-2">{t('chat.unavailable')}</h2>
      <p className="text-dark-muted text-center">
        {error || t('chat.unavailableMessage')}
      </p>
    </div>
  );
}

